module.exports = __webpack_public_path__ + "img/add_new_books.23bfe2ea.png";